import React, { FC, PropsWithChildren, memo } from 'react';
import RcTooltip from 'rc-tooltip';
import classNames from 'classnames';

import { TooltipProps } from './interfaces';

import useStyles from './style';

const Tooltip: FC<PropsWithChildren<TooltipProps>> = ({
  className,
  children,
  overlay,
  isNoWrapEnabled = false,
  fillOverlay = false,
  type = 'default',
  placement = 'bottom',
  trigger = ['hover'],
  ...rest
}) => {
  const classes = useStyles();

  const offsetWithShift = placement === 'top' ? [0, -5] : [2, 6];

  return (
    <RcTooltip
      placement={placement}
      trigger={trigger}
      overlay={overlay}
      mouseLeaveDelay={0}
      mouseEnterDelay={0.4}
      align={{
        offset: offsetWithShift,
      }}
      getTooltipContainer={() => {
        const nodes = document.querySelectorAll('.rc-dialog-content');

        return (nodes[nodes.length - 1] as HTMLElement) || document.body;
      }}
      {...rest}
      overlayClassName={classNames(
        'viboTooltipOvelay',
        classes.viboTooltipOvelay,
        `${type}Display`,
        {
          fillOverlay,
          withSizeLimit: isNoWrapEnabled,
        },
        className
      )}
      overlayStyle={{ display: !!overlay ? '' : 'none', ...rest.overlayStyle }}
      transitionName="rc-tooltip-zoom"
    >
      {children}
    </RcTooltip>
  );
};

export default memo(Tooltip);
